// extracted by mini-css-extract-plugin
module.exports = {"checkbox-btn":"checkbox-btn--9bd5s","checkbox-btn__input":"checkbox-btn__input--9bd5s","checkbox-btn__label":"checkbox-btn__label--9bd5s"};